(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-footer"]) return;
  try {
    
  if (!customElements.get('dg-site-footer')) {
    customElements.define('dg-site-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.media = window.matchMedia('(max-width: 700px)');
        this.groups = [...this.querySelectorAll('.dg-footer-group')];
        const sync = () => {
          this.groups.forEach((group) => {
            group.open = !this.media.matches;
            group.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
          });
        };
        this.groups.forEach((group) => {
          group.querySelector('summary').addEventListener('click', (event) => {
            if (!this.media.matches) event.preventDefault();
          }, options);
        });
        this.media.addEventListener('change', sync, options);
        sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-header"]) return;
  try {
    
  if (!customElements.get('dg-site-header')) {
    customElements.define('dg-site-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.menu = this.querySelector('[data-dg-menu]');
        this.summary = this.menu.querySelector('summary');
        this.media = window.matchMedia('(min-width: 1001px)');
        const close = (restoreFocus = false) => {
          if (!this.menu.open) return;
          this.menu.open = false;
          if (restoreFocus) this.summary.focus();
        };
        this.menu.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', String(this.menu.open));
        }, options);
        this.summary.setAttribute('aria-expanded', String(this.menu.open));
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.menu.open) {
            event.preventDefault();
            close(true);
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.menu.contains(event.target)) close();
        }, options);
        document.addEventListener('focusin', (event) => {
          if (!this.menu.contains(event.target)) close();
        }, options);
        this.menu.addEventListener('click', (event) => {
          if (event.target.closest('a')) close();
        }, options);
        this.media.addEventListener('change', () => {
          if (this.media.matches) close();
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dg-ingredient-tabs')) {
    customElements.define('dg-ingredient-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.tabs = [...this.querySelectorAll('[data-ingredient-tab]')];
        this.panels = [...this.querySelectorAll('[data-ingredient-panel]')];
        this.dataset.enhanced = 'true';
        const anchors = { 'food-freedom-pro': 'ffp', 'gut-prime-pro': 'gpp', 'craving-control-pro': 'ccp' };
        const selectFromHash = (scroll = false) => {
          const key = anchors[window.location.hash.slice(1)];
          const tab = this.tabs.find(item => item.dataset.ingredientTab === key);
          this.select(tab || this.tabs[0]);
          if (tab && scroll) this.scrollIntoView({ block: 'start' });
        };
        selectFromHash();
        if (anchors[window.location.hash.slice(1)]) requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
        window.addEventListener('hashchange', () => selectFromHash(true), { signal: this.abortController.signal });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab), {signal: this.abortController.signal});
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); this.select(this.tabs[next]); this.tabs[next].focus(); }
          }, {signal: this.abortController.signal});
        });
      }
      select(tab) {
        if (!tab) return;
        this.tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.ingredientPanel !== tab.dataset.ingredientTab; });
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-learn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dg-learning-library')) {
    customElements.define('dg-learning-library', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const filters = [...this.querySelectorAll('[data-learning-filter]')];
        const cards = [...this.querySelectorAll('[data-learning-category]')];
        const status = this.querySelector('[data-learning-status]');
        filters.forEach(filter => filter.addEventListener('click', () => {
          let count = 0;
          filters.forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          cards.forEach(card => {
            const visible = filter.dataset.learningFilter === 'all' || card.dataset.learningCategory === filter.dataset.learningFilter;
            card.hidden = !visible;
            if (visible) count++;
          });
          if (status) status.textContent = status.dataset.statusTemplate.replace('__COUNT__', String(count));
        }, {signal: this.abortController.signal}));
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-main-page"]) return;
  try {
    
if (!customElements.get('dg-longform')) {
  customElements.define('dg-longform', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const content = this.querySelector('[data-longform-content]');
      const nav = this.querySelector('[data-longform-nav]');
      if (!content || !nav) return;
      const headings = [...content.querySelectorAll('h2')];
      if (headings.length < 2) return;
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${this.id}-part-${index + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        if (index === 0) link.setAttribute('aria-current', 'location');
        nav.append(link);
      });
      nav.hidden = false;
      this.classList.add('dg-longform--has-nav');
      nav.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link) return;
        nav.querySelectorAll('[aria-current]').forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'location');
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dg-review-library')) {
    customElements.define('dg-review-library', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const controls = this.querySelector('.dg-review-filters');
        if (!controls) return;
        controls.hidden = false;
        const buttons = [...controls.querySelectorAll('[data-review-filter]')];
        const cards = [...this.querySelectorAll('[data-review-product]')];
        const status = this.querySelector('[data-review-status]');
        buttons.forEach(button => button.addEventListener('click', () => {
          let count = 0;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          cards.forEach(card => {
            card.hidden = button.dataset.reviewFilter !== 'all' && button.dataset.reviewFilter !== card.dataset.reviewProduct;
            if (!card.hidden) count++;
          });
          if (status) status.textContent = status.dataset.template.replace('__COUNT__', String(count));
        }, { signal: this.controller.signal }));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
